import Modal from './Modal'

export * from './Modal'
export default Modal

export { ModalMainContainer } from './Modal.style'
